module.exports = __webpack_public_path__ + "img/統計学入門_2_4_問題.903eb540.png";